import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const tabs = [
  "PT-1",
  "PT-2",
  "Half Yearly Examination",
  "PT-3",
  "Annual Examination",
];

const CLASS_RANK = {
  class3: 0,
  classiii: 0,
  class4: 1,
  classiv: 1,
  class5: 2,
  classv: 2,
};

function classRank(label) {
  const key = String(label).toLowerCase().replace(/[^a-z0-9]/g, "");
  return CLASS_RANK[key] ?? 99;
}

function sortByClass(items) {
  return [...items].sort((a, b) => classRank(a.classLabel) - classRank(b.classLabel));
}

const syllabusByTab = {
  "PT-1": [
    {
      classLabel: "Class 3",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Class-III-Syllabus-Term-1.pdf",
    },
    {
      classLabel: "Class 4",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Class-IV-Syllabus-Term-1.pdf",
    },
    {
      classLabel: "Class 5",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Class-V-Syllabus-Term-1.pdf",
    },
  ],
  "PT-2": [
    {
      classLabel: "Class 3",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Term-II-SYLLABUS-class-3.pdf",
    },
    {
      classLabel: "Class 4",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Class-4-Term-2 Syllabus.pdf",
    },
    {
      classLabel: "Class 5",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/CLASS-5-TERM-II-SYLLABUS.pdf",
    },
  ],
  "Half Yearly Examination": [
    {
      classLabel: "Class 3",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Preparatory_Stage/Half_yearly/Class-3_Half_yearly_syllabus.pdf",
    },
    {
      classLabel: "Class 4",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Preparatory_Stage/Half_yearly/Class-4_Half_yearly_syllabus.pdf",
    },
    {
      classLabel: "Class 5",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Preparatory_Stage/Half_yearly/Class_V_half_yearly_syllabus.pdf",
    },
  ],
  "PT-3": [],
  "Annual Examination": [],
};

function pdfHref(fileName) {
  return encodeURI(`${fileName}`);
}

function PreparatoryStage() {
  const [tab, setTab] = useState("PT-1");
  const syllabusItems = sortByClass(syllabusByTab[tab] || []);

  useEffect(() => {
    document.title =
      "Preparatory Stage (III–V) - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus</li>
          <li>Preparatory Stage (III–V)</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Preparatory Stage (III–V)</h1>
            </div>
          </div>

          <nav>
            <div className="nav nav-tabs" role="tablist">
              {tabs.map((name) => (
                <button
                  key={name}
                  type="button"
                  role="tab"
                  className={`nav-link${tab === name ? " active" : ""}`}
                  aria-selected={tab === name}
                  onClick={() => setTab(name)}
                >
                  {name}
                </button>
              ))}
            </div>
          </nav>

          <div className="row mt-4">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={pdfHref(item.fileName)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PreparatoryStage;
